var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar'),_c('v-main',[_c('router-view',{attrs:{"flashMessage":_vm.flashMessage},on:{"updateFlash":function($event){return _vm.updateFlash($event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }